export default {
 // es-MX.js
 help: {
   faq: "Preguntas frecuentes",
   promo: "Promociones",
   contactUs: "Contáctanos",
   joinCommunity: "Únete a nuestra comunidad",
   help: "Ayuda"
 }
};
